import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { productProperty } from 'ngx-core-services';

import { CreateCustomBlockSizeType, ICustomBlock } from '../decorators';

@CreateCustomBlockSizeType({
  'breakpoint-550': 550,
})
@Component({
  selector: 'app-generic-device-dashboard',
  templateUrl: './generic-device-dashboard.component.html',
  styleUrls: ['./generic-device-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericDeviceDashboardComponent implements ICustomBlock  {
  @Input() title = '';
  @Input() uiFramework: 'material' | 'ionic' | string = 'material';
  @Input() status?: productProperty | null = null;
  @Input() deviceId?: string | null = null;
  @Input() deviceTypeLabel?: string;
  @Input() deviceImageSrc?: string;
  @Input() defaultImageSrc?: string;
  @Input() properties: productProperty[] | null = null;
  @Input() skeletonItemsCount = 6;

  get hasProperties(): boolean {
    return !!(this.properties && this.properties.length > 0);
  }

  get resolvedImageSrc(): string | null {
    return this.deviceImageSrc || this.defaultImageSrc || null;
  }

  constructor(
    readonly el: ElementRef,
    readonly renderer: Renderer2,
  ) { }
}